import { QSpinner, QText, QTooltip } from '@qualio/ui-components';
import { User } from '../../../types';

const ActiveUserFilter = ({
  value,
  usersMap,
  isMultiSelect = false,
}: {
  value: unknown;
  usersMap: Record<string, User>;
  isMultiSelect?: boolean;
}) => {
  const id = value as string;
  const user = usersMap[id];
  if (user) {
    if (isMultiSelect) {
      return (
        <QTooltip label={user.email}>
          <QText as="span">{user.full_name}</QText>
        </QTooltip>
      );
    }
    return <QText as="span">{user.full_name}</QText>;
  }
  return <QSpinner size="sm" />;
};

export default ActiveUserFilter;
